/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedTradePointsEarnedMessage_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PointsEarnedMessage_viewer">;
    readonly " $refType": "PdpSharedTradePointsEarnedMessage_viewer";
};
export type PdpSharedTradePointsEarnedMessage_viewer$data = PdpSharedTradePointsEarnedMessage_viewer;
export type PdpSharedTradePointsEarnedMessage_viewer$key = {
    readonly " $data"?: PdpSharedTradePointsEarnedMessage_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedTradePointsEarnedMessage_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedTradePointsEarnedMessage_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PointsEarnedMessage_viewer",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '6cda2d05e2dd49c688da764bafd249d7';
export default node;
